<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="userCategories"
      style="width: 100%"
      :default-sort="tableConfig.sort"
      row-key="id"
      default-expand-all
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            storeModule="userCategory"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :userCategory="scope.row" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
      };
    },
    computed: {
      userCategories() {
        return this.$store.getters['userCategory/userCategories'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['userCategory/tableConfig']));
      },
      loading() {
        return this.$store.getters['userCategory/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      await this.$store.dispatch('userCategory/fetchAll');
    },
  };
</script>

